import _ from 'lodash';
import Globalize from 'wrappers/globalize';

import { truncateNumber } from '@xanadu/ui-shared/utils/numbers';

const currencyFormatters = new Map();

/**
 * Localise a number for display as a currency in the reports.
 * @param  {Number}  [amount=0]           The amount ot render
 * @param  {String}  [curr='USD']         The currency to do it in (currently has no effects)
 * @param  {object}  options
 * @param  {boolean} options.symbol=false Show/Hide the currency symbol
 * @return {string}                       The amount as a localised string
 */
export const currency = (amount = 0, curr = 'USD', options = {}) => {
  const {
    symbol = false,
    maximumFractionDigits = 2,
    minimumFractionDigits = 2
  } = options;

  const key = [curr, symbol].join('-');

  if (!currencyFormatters.get(key)) {
    if (symbol) {
      currencyFormatters.set(key, Globalize.currencyFormatter(curr, {
        maximumFractionDigits,
        minimumFractionDigits
      }));
    } else {
      currencyFormatters.set(key, Globalize.numberFormatter({
        maximumFractionDigits,
        minimumFractionDigits
      }));
    }
  }

  return currencyFormatters.get(key)(amount);
};

const oddsFormatters = new Map();

export const odds = _.memoize(
  (input, { oddsType, side, isMBZero }) => {
    const value = parseFloat(input, 10);
    const round = side === 'lay' ? 'ceil' : 'floor';
    let maximumFractionDigits = 3;
    let prefix = '';

    switch (oddsType) {
      case 'US':
        maximumFractionDigits = 5;

        if (value > 0) {
          prefix = '+';
        }
        break;
      case 'DECIMAL':
        if (value < 1.01) {
          maximumFractionDigits = 5;
        }
        break;
      default:
    }

    const key = [round, maximumFractionDigits].join('_');

    if (!oddsFormatters.has(key)) {
      oddsFormatters.set(
        key,
        Globalize.numberFormatter({
          round,
          maximumFractionDigits,
          useGrouping: false,
        })
      );
    }

    const localisedNumber = oddsFormatters.get(key)(value);

    // MBZero uses only DECIMAL odds-type
    if (isMBZero) {
      return parseFloat(truncateNumber(input, 2));
    }

    if (oddsType === 'US') {
      return `${prefix}${parseFloat(truncateNumber(localisedNumber, 2))}`;
    }

    return `${prefix}${localisedNumber}`;
  },
  (value, { oddsType, side, isMBZero }) => [value, oddsType, side, isMBZero].join('_')
);
